import React, { Component } from 'react';
import { Modal, Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import styles from './styles.module.less';
import closeImage from './img/manage-close.png';

const isRequireInput = [
  {
    key: 'userName',
    name: '用户名称',
  },
  {
    key: 'mobile',
    name: '手机号',
  },
  {
    key: 'address',
    name: '地址',
  },
];

const propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  visible: PropTypes.bool,
};
const defaultProps = {
  visible: false,
};

/**
 * 发票 modal
 */
class InvoiceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceRiseType: 0,
      invoiceRise: '',
      taxNum: '',
      userName: '',
      mobile: '',
      address: '',
      remark: '',
    };
  }

  handleChange = (key) => (event) => {
    const { value } = event.target;
    this.setState({ [key]: value });
  };

  handleChangeType = (value) => {
    this.setState({ invoiceRiseType: value });
  };

  handleConfirm = () => {
    const { onSuccess, amount } = this.props;
    const {
      invoiceRiseType, taxNum, invoiceRise, mobile,
    } = this.state;

    if (invoiceRiseType === 1 && !invoiceRise) { return Toast.show('请填写发票抬头', 0.8); }
    if (invoiceRiseType === 1 && !taxNum) return Toast.show('请填写税号', 0.8);

    // eslint-disable-next-line react/destructuring-assignment
    const hasNullObj = isRequireInput.find(({ key }) => !this.state[key]);
    if (hasNullObj) return Toast.show(`请填写${hasNullObj.name}`, 0.8);

    if (mobile.length !== 11) return Toast.show('请检查手机号', 0.8);

    const data = { ...this.state, amount };

    onSuccess(data);
    return true;
  };

  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  };

  render() {
    const { onCancel, visible, amount } = this.props;
    const {
      invoiceRiseType,
      invoiceRise,
      taxNum,
      userName,
      mobile,
      address,
      remark,
    } = this.state;
    const typeActive = ClassNames(
      styles.selectTabActive,
      styles.selectTabDefault,
    );
    return (
      <Modal
        popup
        visible={visible}
        animationType="slide-up"
        className={styles.modalContentRadius}
        maskClosable
        onClose={onCancel}
      >
        <div className={styles.invoiceContent}>
          <div className={styles.header}>
            <p className={styles.headerFont}>发票</p>
            <span className={styles.notice}>
              纸质普通发票，在开票后15天内将进行邮寄
            </span>
            <span className={styles.close} onClick={onCancel} role="button" tabIndex={0}>
              <img src={closeImage} alt="closeImage" />
            </span>
          </div>
          <div className={styles.scrollContent}>
            <div className={styles.invoiceModalItem}>
              <p className={styles.titleFont}>发票类型</p>
              <div className={styles.modalText}>
                <span
                  className={
                    invoiceRiseType === 0 ? typeActive : styles.selectTabDefault
                  }
                  onClick={this.handleChangeType.bind(null, 0)}
                  role="button"
                  tabIndex={0}
                >
                  个人-纸质普通发票
                </span>
                <span
                  className={
                    invoiceRiseType === 1 ? typeActive : styles.selectTabDefault
                  }
                  onClick={this.handleChangeType.bind(null, 1)}
                  role="button"
                  tabIndex={0}
                >
                  企业-纸质增值税发票
                </span>
              </div>
            </div>

            <div className={styles.invoiceModalItem}>
              <p className={styles.titleFont}>发票信息</p>
              <div>
                <div className={styles.noticeModalItem}>
                  <span className={styles.label}>发票抬头</span>
                  <input
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus
                    type="text"
                    value={invoiceRise}
                    placeholder={
                      invoiceRiseType === 1
                        ? '必填，发票抬头'
                        : '选填，发票抬头'
                    }
                    onBlur={this.scrollPosition}
                    onChange={this.handleChange('invoiceRise')}
                  />
                </div>
                {invoiceRiseType === 1 && (
                  <div className={styles.noticeModalItem}>
                    <span className={styles.label}>税号</span>
                    <input
                      type="text"
                      value={taxNum}
                      onBlur={this.scrollPosition}
                      placeholder="必填，税号"
                      onChange={this.handleChange('taxNum')}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className={styles.invoiceModalItem}>
              <p className={styles.titleFont}>收票人信息</p>
              <div>
                <div className={styles.noticeModalItem}>
                  <span className={styles.label}>姓名</span>
                  <input
                    type="text"
                    value={userName}
                    onBlur={this.scrollPosition}
                    placeholder="必填，收票人姓名"
                    onChange={this.handleChange('userName')}
                  />
                </div>
                <div className={styles.noticeModalItem}>
                  <span className={styles.label}>手机号</span>
                  <input
                    type="number"
                    value={mobile}
                    maxLength={11}
                    onBlur={this.scrollPosition}
                    placeholder="必填，收票人手机号"
                    onChange={this.handleChange('mobile')}
                  />
                </div>
                <div className={styles.noticeModalItem}>
                  <span className={styles.label}>地址</span>
                  <input
                    type="text"
                    value={address}
                    onBlur={this.scrollPosition}
                    placeholder="必填，收票人地址"
                    onChange={this.handleChange('address')}
                  />
                </div>
                <div className={styles.noticeModalItem}>
                  <span className={styles.label}>备注</span>
                  <input
                    type="text"
                    value={remark}
                    onBlur={this.scrollPosition}
                    placeholder="选填，备注"
                    onChange={this.handleChange('remark')}
                  />
                </div>
              </div>
            </div>

            <div className={styles.moneyBox}>
              开票金额：
              <span className={styles.money}>{amount}</span>
            </div>
          </div>
          <div className={styles.buyButton} onClick={this.handleConfirm} role="button" tabIndex={0}>
            确定
          </div>
        </div>
      </Modal>
    );
  }
}

InvoiceModal.propTypes = propTypes;
InvoiceModal.defaultProps = defaultProps;

export default InvoiceModal;
